import type { ApiPreset, ApiScope } from '@/api/types';

/** «Интеграции» (MK42-6384): the rights of a key in the cabinet's words. */

/** «Документация API» inside the cabinet (MK42-6385): the owner only, after sign-in. */
export const API_DOCS_URL = '/settings/api';

export const SCOPE_LABEL: Record<ApiScope, string> = {
  'read:projects': 'проекты',
  'read:tasks': 'задачи',
  'read:reports': 'отчёты',
  'read:initiatives': 'идеи и запросы',
  'write:initiatives': 'новые идеи и ответы',
  'read:documents': 'документы',
  'read:money': 'счета и акты',
  'write:money': 'отметка «оплачено переводом»',
};

const READ_ALL: ApiScope[] = ['read:documents', 'read:initiatives', 'read:money', 'read:projects', 'read:reports', 'read:tasks'];

export const PRESETS: { value: ApiPreset; label: string; hint: string; scopes: ApiScope[] }[] = [
  { value: 'accounting', label: 'Бухгалтерия', hint: 'Счета, акты, отметка «оплачено переводом»: 1С, Контур, МойСклад.', scopes: ['read:money', 'write:money'] },
  { value: 'reports', label: 'Отчёты', hint: 'Проекты и отчёты: BI, таблицы.', scopes: ['read:projects', 'read:reports'] },
  { value: 'ideas', label: 'Идеи', hint: 'Идеи и запросы из CRM или трекера, ответы на вопросы студии.', scopes: ['read:initiatives', 'write:initiatives', 'read:projects'] },
  { value: 'read', label: 'Всё на чтение', hint: 'Всё, что видно в кабинете, без записи.', scopes: READ_ALL },
];

/** The preset's name when the rights are exactly a preset, else the rights one by one. */
export function scopesLabel(scopes: ApiScope[]): string {
  const sorted = [...scopes].sort().join(' ');
  const preset = PRESETS.find((p) => [...p.scopes].sort().join(' ') === sorted);
  if (preset) return preset.label;
  const read = scopes.filter((s) => s.startsWith('read:')).map((s) => SCOPE_LABEL[s]);
  const write = scopes.filter((s) => s.startsWith('write:')).map((s) => SCOPE_LABEL[s]);
  return [read.length && `чтение: ${read.join(', ')}`, write.length && `запись: ${write.join(', ')}`].filter(Boolean).join('; ');
}
